// Port of webapp/src/components/kanban/kanbanCard.tsx

import {DragEvent, MouseEvent, ReactElement} from 'react'
import classnames from 'classnames'
import {IPropertyTemplate} from '../../types/board'
import {Card} from '../../types/card'
import {IUser} from '../../types/user'
import PropertyValue from '../propertyValue'

type Props = {
    card: Card
    activeProps: IPropertyTemplate[]
    usersById: Record<string, IUser>
    onClick: (cardId: string) => void
    onDragStart?: (event: DragEvent<HTMLDivElement>, card: Card) => void
    onDragEnd?: (event: DragEvent<HTMLDivElement>) => void
    onDropOnCard?: (event: DragEvent<HTMLDivElement>, card: Card) => void
    isDragging?: boolean
}

export default function KanbanCard({card, activeProps, usersById, onClick, onDragStart, onDragEnd, onDropOnCard, isDragging}: Props): ReactElement {
    const icon = card.fields.icon

    const handleDragStart = (event: DragEvent<HTMLDivElement>): void => {
        event.dataTransfer.setData('text/plain', card.id)
        event.dataTransfer.effectAllowed = 'move'
        onDragStart?.(event, card)
    }

    const handleDrop = (event: DragEvent<HTMLDivElement>): void => {
        event.preventDefault()
        event.stopPropagation()
        onDropOnCard?.(event, card)
    }

    return (
        <div
            className={classnames('octo-board-cell', 'group')}
            data-card-id={card.id}
        >
            <div
                className={classnames('BoardCard cursor-pointer', isDragging && 'opacity-40')}
                draggable={true}
                onDragStart={handleDragStart}
                onDragEnd={onDragEnd}
                onDrop={handleDrop}
                onDragOver={(event) => event.preventDefault()}
                onClick={(event: MouseEvent<HTMLDivElement>) => {
                    event.stopPropagation()
                    onClick(card.id)
                }}
                role='button'
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        onClick(card.id)
                    }
                }}
                aria-label={card.title || '未命名'}
            >
                <div className='mb-2 flex items-start gap-2'>
                    {icon && <span className='text-base leading-none'>{icon}</span>}
                    <span className={classnames('flex-1 font-semibold leading-snug break-words', !card.title && 'opacity-40')}>
                        {card.title || '未命名'}
                    </span>
                </div>

                {activeProps.length > 0 && (
                    <div className='flex flex-wrap items-center gap-x-2 gap-y-1'>
                        {activeProps.map((template) => (
                            <PropertyValue
                                key={template.id}
                                template={template}
                                card={card}
                                usersById={usersById}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
